<template>
  <div class="widget-wrapper">
    <label
      v-bind:for="name"
      v-bind:class="milimeter ? 'milimeter' : null"
    >{{ label }}</label>
    <div class="input-wrapper">
      <input
        type="number"
        v-bind:name="name"
        v-bind:min="min"
        v-bind:max="max"
        v-bind:step="step"
        v-bind:value="value"
        v-on:input="$emit('input', $event.target.value)">
      <span class="input-arrow up" v-on:click="increaseValue">▲</span>
      <span class="input-arrow down" v-on:click="decreaseValue">▼</span>
    </div>
    <div class="axis" ref="axis">
      <input
        type="range"
        v-bind:name="name"
        v-bind:min="min"
        v-bind:max="max"
        v-bind:step="step"
        v-bind:value="value"
        v-on:input="$emit('input', $event.target.value)"
        v-bind:style="progressBarStyle">
      <div class="endpoints-wrapper">
        <span class="endpoint left"></span>
        <span class="endpoint-label left">{{ min }}</span>
        <span class="endpoint right"></span>
        <span class="endpoint-label right">{{ max }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RingsCalculatorInputNumber',
  props: {
    value: { type: Number },
    label: { type: String },
    name: { type: String },
    min: { type: Number },
    max: { type: Number },
    step: { type: Number },
    milimeter: { type: Boolean, default: false }
  },
  data: function () {
    return {}
  },
  computed: {
    progressBarStyle: function () {
      if ((this.value >= this.min) && (this.value <= this.max)) {
        let progress = (this.value - this.min) / (this.max - this.min) * 100
        return {
          background: `linear-gradient(
          to right,
          #cdcdcd 0%,
          #cdcdcd ${progress}%,
          transparent ${progress}%,
          transparent 100%)`
        }
      } else {
        return {}
      }
    }
  },
  methods: {
    increaseValue: function (event) {
      if (this.value < this.max) {
        let value = this.value + this.step
        this.$emit('input', value.toFixed(2))
      }
    },
    decreaseValue: function (event) {
      if (this.value > this.min) {
        let value = this.value - this.step
        this.$emit('input', value.toFixed(2))
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .widget-wrapper {
    width: 120px;

    & > label {
      display: block;
      text-align: left;
      text-transform: uppercase;
      font-family: "Gotham Pro Regular", $font-stack;
      color: $default-heading-color;
      padding-bottom: 0.5em;
    }
    & > label.milimeter::after {
      content: " (мм)";
      text-transform: lowercase;
    }

    .input-wrapper {
      position: relative;

      input[type=number] {
        background-color: $content-background-color;
        box-sizing: border-box;
        border: 0;
        color: $default-text-color;
        padding: 0.33em 0.5em;
        width: 100%;
        -moz-appearance: textfield;

        &::-webkit-outer-spin-button,
        &::-webkit-inner-spin-button {
          -webkit-appearance: none;
          margin: 0;
        }
      }
      .input-arrow {
        color: $default-link-color;
        cursor: pointer;
        position: absolute;
        right: 0.75em;
        font-size: 0.75em;
        &.up { top: 0.1em; }
        &.down { bottom: 0.1em; }
      }
    }
    .axis {
      border-top: 1px solid $default-text-color;
      box-sizing: border-box;
      position: relative;
      height: calc(5px + 0.75em);

      input[type=range] {
        /* Hides the slider so that custom slider can be made */
        appearance: none;
        -webkit-appearance: none;
        width: 100%;
        height: 1px;
        background: linear-gradient(
          to right,
          #cdcdcd 0%,
          #cdcdcd 0%,
          transparent 0%,
          transparent 100%
        );
        position: absolute;
        top: -1px;
        left: 0;

        &::-webkit-slider-thumb {
          -webkit-appearance: none;
          height: 0;
          width: 0;
          border-top: 0;
          border-left: 0.25em solid transparent;
          border-right: 0.25em solid transparent;
          border-bottom: 0.5em solid $default-link-color;
          cursor: pointer;
        }
        &::-moz-range-thumb {
          height: 0;
          width: 0;
          background-color: transparent;
          border-radius: 0;
          border-right: 0;
          border-top: 0.25em solid transparent;
          border-bottom: 0.25em solid transparent;
          border-left: 0.5em solid $default-link-color;
          cursor: pointer;
        }
        &::-webkit-slider-runnable-track {
          width: 100%;
          height: 1px;
          cursor: pointer;
          margin: 0 -0.25em 0 -0.25em;
        }

        &:focus {
          outline: none; /* Removes the blue border. You should probably
          do some kind of focus styling for accessibility reasons though. */
        }
        &::-ms-track {
          width: 100%;
          cursor: pointer;

          /* Hides the slider so custom styles can be added */
          background: transparent;
          border-color: transparent;
          color: transparent;
        }
      }
      .endpoints-wrapper {
        position: absolute;
        top: -1px;
        left: 0;
        width: 100%;
        .endpoint {
          background-color: $default-link-color;
          border-radius: 50%;
          display: inline-block;
          position: absolute;
          top: -3px;
          width: 6px;
          height: 6px;
          &.left { left: -3px; }
          &.right { right: -3px; }
        }
        .endpoint-label {
          display: inline-block;
          background-color: $content-background-color;
          position: absolute;
          font-size: 0.75em;
          top: 0.75em;
          &.left {
            left: 0;
            transform: translateX(-50%);
          }
          &.right {
            right: 0;
            transform: translateX(50%);
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/the-content/RingsCalculatorInputNumber.vue